import { Directive, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { take } from "rxjs/operators";
import { FormTrackingConfig } from "src/app/config/eev-form-tracking.config";
import { AuthEventType } from "src/app/enums/event/event.enum";
import { FormFillStart } from "src/app/models/event-data.model";
import { EventTrackingService } from "src/app/services/event-tracking.service";

@Directive({
    selector: '[eevTrackFormStart]',
    standalone: false
})
export class EEVTrackFormStartDirective implements OnInit {
    constructor(
        private eventTrackingService: EventTrackingService
    ) {}

    ngOnInit() {
        const shouldTrack = this.formGroup && this.eevFormTrackingConfig;
        if (shouldTrack) {
            const formStartPayload = this.eevFormTrackingConfig.formStartEvent;
            this.formGroup.valueChanges.pipe(take(1)).subscribe(
                () => this.eventTrackingService.trackEvent<FormFillStart>(AuthEventType.FORM_START, formStartPayload)
            )
        }
    }

    @Input() formGroup: FormGroup
    @Input() eevFormTrackingConfig: FormTrackingConfig
}